import gql from 'graphql-tag'

export  const TOKENS = gql`
    query Tokens ($tokenType: String!) {
        tokens (tokenType: $tokenType){
            id,
            email,
            expirationDate
        }   
    }`